import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * hallmark critique · StopMarkers
 * tokens locked from docs/design.md §1 (pebble border) + §5 (17px caption text)
 * states covered: idle · hover (tooltip)
 * mobile verified: 320 / 375 / 414 / 768
 * no fake chrome · no italic headers · no shadows · single clay accent per viewport
 *
 * Small pebble circles at each of the 7 AS-4 stops with a Leaflet tooltip
 * (name) on hover. No shadows — flat surface shift only.
 */
import { CircleMarker, Tooltip } from "react-leaflet";
export function StopMarkers({ stops }) {
    return (_jsx(_Fragment, { children: stops.map((s, i) => (_jsx(CircleMarker, { center: [s.lat, s.lng], radius: 6, pathOptions: {
                color: "#000d10",
                weight: 2,
                fillColor: "#ffffff",
                fillOpacity: 1,
            }, children: _jsx(Tooltip, { direction: "top", offset: [0, -6], opacity: 1, sticky: true, children: `${String(i + 1).padStart(2, "0")} · ${s.name}` }) }, s.stopId))) }));
}
